(() => {
  const applyStorefrontFallbacks = () => {
    const replaceExactText = (from, to) => {
      document.querySelectorAll("span, strong, p, h2, h3, small").forEach((node) => {
        if ((node.textContent || "").trim() === from) node.textContent = to;
      });
    };

    replaceExactText("Multi-unit buying", "Bundle & save");
    replaceExactText("Choose more units of this same product.", "Add more units of this same product.");
    replaceExactText(
      "Bundle price preview for this same product only. Checkout discount rule still needs Shopify Function activation.",
      "Bundle discount is applied with a product-specific checkout code and does not combine mixed products."
    );
    replaceExactText(
      "Bundle preview is calculated only for this product. Final Shopify checkout total is shown before payment.",
      "Bundle discount is applied with a product-specific checkout code and does not combine mixed products."
    );
    replaceExactText("Contact and returns pages", "Contact and returns support");
    replaceExactText("Reviews are being matched for this product.", "Product reviews are being verified.");

    document.querySelectorAll("p").forEach((node) => {
      const text = (node.textContent || "").trim();

      if (text === "Use the returns page or contact support if the order arrives different from the selected option.") {
        node.textContent = "Contact support if the order arrives different from the selected option.";
      }

      if (text === "Use the Returns page for the current policy. If the item arrives different from the selected option, contact support with order photos.") {
        node.textContent = "If the item arrives different from the selected option, contact support with order photos.";
      }
    });

    document.querySelectorAll("details, .rte, .product-description, .product-specs, .product-specification, [class*='description'], [class*='specification']").forEach((node) => {
      const text = node.textContent || "";
      if (/SPECIFICATIONS|Mainland China|Brand Name|AliExpress|Origin:/i.test(text)) {
        node.setAttribute("hidden", "hidden");
        node.setAttribute("aria-hidden", "true");
      }
    });

    document.querySelectorAll('a[href="/policies/contact-information"], a[href="/policies/shipping-policy"], a[href="/policies/refund-policy"], a[href="/policies/terms-of-service"]').forEach((link) => {
      const label = (link.textContent || "").trim().toLowerCase();
      if (label.includes("contact")) {
        link.setAttribute("href", "mailto:fgon@redsoftchile.cl");
      } else if (label.includes("shipping")) {
        link.setAttribute("href", "#shipping-info");
      } else if (label.includes("return")) {
        link.setAttribute("href", "#returns-info");
      } else if (label.includes("term")) {
        link.setAttribute("href", "#terms-info");
      }
    });

    const footer = document.querySelector(".site-footer");
    if (footer && !footer.querySelector(".footer-support-grid")) {
      const supportGrid = document.createElement("div");
      supportGrid.className = "footer-support-grid";
      supportGrid.setAttribute("aria-label", "Store support information");
      supportGrid.innerHTML = `
        <section id="shipping-info">
          <strong>Shipping</strong>
          <p>Delivery timing is shown at checkout. Tracking is shared after fulfillment is confirmed for the selected product and variant.</p>
        </section>
        <section id="returns-info">
          <strong>Returns support</strong>
          <p>If an item arrives different from the selected option, contact support with your order number and photos so the case can be reviewed.</p>
        </section>
        <section id="terms-info">
          <strong>Order terms</strong>
          <p>Review product photos, dimensions, selected variant and checkout total before payment. Kirelot support can help with order questions.</p>
        </section>
      `;
      const footerBottom = footer.querySelector(".footer-bottom");
      footer.insertBefore(supportGrid, footerBottom || null);
    }
  };

  applyStorefrontFallbacks();

  const nav = document.querySelector("[data-main-nav]");
  const toggle = document.querySelector("[data-menu-toggle]");

  if (nav && toggle) {
    toggle.addEventListener("click", () => {
      const isOpen = nav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", String(isOpen));
    });
  }

  document.querySelectorAll("[data-scroll-target]").forEach((button) => {
    button.addEventListener("click", () => {
      const target = document.querySelector(button.getAttribute("data-scroll-target"));
      if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });

  document.querySelectorAll("[data-product-gallery]").forEach((gallery) => {
    const mainImage = gallery.querySelector("[data-product-main-image]");
    const thumbs = gallery.querySelectorAll("[data-product-thumb]");

    if (!mainImage || thumbs.length === 0) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        const nextSrc = thumb.getAttribute("data-full");
        if (!nextSrc || mainImage.src === nextSrc) return;

        thumbs.forEach((item) => item.classList.remove("is-active"));
        thumb.classList.add("is-active");

        mainImage.style.opacity = "0";
        window.setTimeout(() => {
          mainImage.removeAttribute("srcset");
          mainImage.removeAttribute("sizes");
          mainImage.src = nextSrc;
          mainImage.alt = thumb.getAttribute("data-alt") || mainImage.alt;
          mainImage.style.opacity = "1";
        }, 140);
      });
    });
  });

  document.querySelectorAll("[data-product-purchase]").forEach((form) => {
    const quantityInput = form.querySelector("[data-quantity-input]");
    const decreaseButton = form.querySelector("[data-quantity-decrease]");
    const increaseButton = form.querySelector("[data-quantity-increase]");
    const variantSelect = form.querySelector('select[name="id"]');
    const bundleOptions = Array.from(form.querySelectorAll("[data-bundle-quantity]"));
    const currentPrice = document.querySelector("[data-current-price]");
    const pricePreview = form.querySelector("[data-price-preview]");
    const discountLabel = pricePreview?.querySelector("[data-discount-label]");
    const totalPrice = pricePreview?.querySelector("[data-total-price]");
    const unitPrice = pricePreview?.querySelector("[data-unit-price]");
    const savingsText = pricePreview?.querySelector("[data-savings-text]");
    const submitNote = form.querySelector("[data-submit-note]");
    const returnToInput = form.querySelector("[data-bundle-return-to]");

    if (!quantityInput) return;

    const currency = form.getAttribute("data-currency") || "USD";
    const locale = document.documentElement.lang || "en-US";
    const productId = form.getAttribute("data-product-id");

    const formatMoney = (cents) => {
      const amount = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat(locale, {
          style: "currency",
          currency,
          currencyDisplay: "narrowSymbol",
        }).format(amount);
      } catch (error) {
        return `$${amount.toFixed(2)}`;
      }
    };

    const getUnitPriceCents = () => {
      const selectedOption = variantSelect?.selectedOptions?.[0];
      const selectedPrice = Number(selectedOption?.getAttribute("data-price-cents"));
      if (Number.isFinite(selectedPrice) && selectedPrice > 0) return selectedPrice;

      const basePrice = Number(form.getAttribute("data-base-price-cents"));
      return Number.isFinite(basePrice) ? basePrice : 0;
    };

    const getQuantity = () => {
      const quantity = Number.parseInt(quantityInput.value, 10);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    };

    const getDiscountRate = (quantity) => {
      if (quantity >= 3) return 0.1;
      if (quantity >= 2) return 0.05;
      return 0;
    };

    const getBundleLabel = (quantity, discountRate) => {
      if (discountRate > 0) {
        return `${quantity} same-product units - ${Math.round(discountRate * 100)}% bundle`;
      }

      return "Single item";
    };

    const getBundleCode = (quantity) => {
      if (!productId) return "";
      if (quantity >= 3) return `KIRELOT3-${productId}`;
      if (quantity >= 2) return `KIRELOT2-${productId}`;
      return "";
    };

    const getActiveBundleQuantity = (quantity) => {
      if (quantity >= 3) return "3";
      if (quantity >= 2) return "2";
      return "1";
    };

    const updateBundleOptions = (unitCents, quantity) => {
      const activeQuantity = getActiveBundleQuantity(quantity);

      bundleOptions.forEach((option) => {
        const optionQuantity = Number.parseInt(option.getAttribute("data-bundle-quantity"), 10) || 1;
        const optionDiscount = Number(option.getAttribute("data-bundle-discount")) || 0;
        const discountedUnit = Math.round(unitCents * (1 - optionDiscount));
        const preview = option.querySelector("[data-bundle-unit-preview]");
        const isActive = option.getAttribute("data-bundle-quantity") === activeQuantity;

        option.classList.toggle("is-active", isActive);
        option.setAttribute("aria-pressed", String(isActive));

        if (preview) {
          preview.textContent = optionQuantity === 1
            ? formatMoney(unitCents)
            : `${formatMoney(discountedUnit)} each`;
        }
      });
    };

    const updatePricePreview = () => {
      const quantity = getQuantity();
      const unitCents = getUnitPriceCents();
      const discountRate = getDiscountRate(quantity);
      const discountedUnitCents = Math.round(unitCents * (1 - discountRate));
      const fullTotalCents = unitCents * quantity;
      const discountedTotalCents = Math.round(fullTotalCents * (1 - discountRate));
      const savingsCents = Math.max(0, fullTotalCents - discountedTotalCents);

      if (currentPrice) currentPrice.textContent = formatMoney(unitCents);
      if (discountLabel) discountLabel.textContent = getBundleLabel(quantity, discountRate);
      if (totalPrice) totalPrice.textContent = formatMoney(discountedTotalCents);
      if (unitPrice) unitPrice.textContent = formatMoney(discountedUnitCents);
      if (savingsText) {
        savingsText.textContent = savingsCents > 0
          ? `Preview save ${formatMoney(savingsCents)}`
          : "";
      }
      if (submitNote) {
        submitNote.textContent = quantity > 1
          ? `Bundle checkout ${formatMoney(discountedTotalCents)}`
          : `Estimated total ${formatMoney(discountedTotalCents)}`;
      }
      if (returnToInput) {
        const bundleCode = getBundleCode(quantity);
        returnToInput.value = bundleCode
          ? `/discount/${encodeURIComponent(bundleCode)}?redirect=/checkout`
          : "/checkout";
      }

      updateBundleOptions(unitCents, quantity);
    };

    const setQuantity = (value) => {
      const quantity = Math.max(1, Number.parseInt(value, 10) || 1);
      quantityInput.value = String(quantity);
      updatePricePreview();
    };

    decreaseButton?.addEventListener("click", () => setQuantity(getQuantity() - 1));
    increaseButton?.addEventListener("click", () => setQuantity(getQuantity() + 1));

    bundleOptions.forEach((option) => {
      option.addEventListener("click", () => {
        setQuantity(option.getAttribute("data-bundle-quantity"));
      });
    });

    quantityInput.addEventListener("input", updatePricePreview);
    quantityInput.addEventListener("change", () => setQuantity(getQuantity()));
    variantSelect?.addEventListener("change", updatePricePreview);

    updatePricePreview();
  });
})();
